import React from 'react';

function numberFormat(value) {
  const INRFormat = new Intl.NumberFormat('en-IN', {
    currency: 'INR',
    minimumFractionDigits: 2,
  });
  return (
    <span>
      {/* <span
        style={{
          fontWeight: 'normal',
          fontSize: '1rem',
          top: '-0.4em',
          position: 'relative',
        }}
      > */}
      ₹ {/* </span> */}
      {INRFormat.format(value)}
    </span>
  );
}
export default numberFormat;
